module.exports = __webpack_public_path__ + "img/secondpic3.09e96b6d.png";